import React, { useState, useEffect, useRef } from 'react'
import { StyleSheet, css } from 'aphrodite'
import ScrollText from './ScrollText'

const LayoutPreview = (props) => {
  const {
    layoutJson,
    renderDimensions,
    onChangeSectionSelection = null,
    selectedItem = null,
    displayMedia = false
  } = props

  const containerRef = useRef(null)

  const [scaleXY, setScaleXY] = useState({ x: 1, y: 1 })
  const [selectedSection, setSelectedSection] = useState(null)
  const [mediaIndexes, setMediaIndexes] = useState({}); // Tracks the current media index for each section

  useEffect(() => {
    handleResize()
    // window.addEventListener('resize', handleResize)
    // return () => {
    //   window.removeEventListener('resize', handleResize)
    // }
  }, [layoutJson, renderDimensions])

  useEffect(() => {
    if (selectedItem) setSelectedSection(selectedItem)
  }, [selectedItem])

  // Initialize media playback for each section
  useEffect(() => {
    if (displayMedia && layoutJson && layoutJson.layoutjson) {
      const timers = {};
      layoutJson.layoutjson.sections.forEach((section) => {
        if (section.media && section.media.length > 0) {
          playMediaForSection(section, 0, timers);
        }
      });
      return () => {
        // Cleanup all timers
        Object.values(timers).forEach(clearTimeout);
      };
    }
  }, [layoutJson, displayMedia]);

  const handleOnChangeSectionSelection = (data) => {
    console.log('handleOnChangeSectionSelection', data)
    const { item, index } = data
    if (onChangeSectionSelection && item && (index || index === 0)) {
      onChangeSectionSelection(data)
      setSelectedSection(item)
    }
  }


  const handleResize = () => {
    if (!containerRef.current || !layoutJson || !layoutJson.layoutjson) {
      return
    }
    const containerWidth = containerRef.current.clientWidth
    const containerHeight = containerRef.current.clientHeight

    if (containerWidth <= 0 || containerHeight <= 0) {
      return
    }
    const scaleX = containerWidth / layoutJson.width
    const scaleY = containerHeight / layoutJson.height
    setScaleXY({ x: scaleX, y: scaleY })
  }

  const playMediaForSection = (section, index, timers) => {
    const mediaItems = section.media
    if (!mediaItems || mediaItems.length === 0) return

    setMediaIndexes((prev) => ({
      ...prev,
      [section.id]: index,
    }));

    const currentMedia = mediaItems[index];
    const duration = (currentMedia.durationSecs || 5) * 1000

    // Set a timeout to move to the next media
    timers[section.id] = setTimeout(() => {
      const nextIndex = (index + 1) % mediaItems.length
      playMediaForSection(section, nextIndex, timers)
    }, duration)
  }

  const renderMedia = (media, sectionStyle = {}) => {
    switch (media.iType) {
    case 'IMAGE':
      return <img src={media.content} alt={media.title} style={{ width: '100%', height: '100%', objectFit: 'fill' }} />
    case 'VIDEO':
      return <video src={media.content} autoPlay muted loop style={{ width: '100%', height: '100%', objectFit: 'fill' }} />
    case 'WEBLINK':
      return <iframe src={media.contentName} style={{ width: '100%', height: '100%', objectFit: 'fill' }} title={media.title} />
    case 'TEXT':
      return <ScrollText key={media.id} media={media} sectionStyle={sectionStyle}></ScrollText>
    case 'HDMI-IN':
      return (<div className={css(Styles.hdmiIconContainer)}>
        <img src={require('../assets/icons/mediaDnd/hdmi-img.png')} alt={media.title} style={{ width: '100%', maxHeight: '100%', objectFit: 'contain', maxWidth: '70%' }} />
      </div>)
    case 'CMS':
      return (<div className={css(Styles.hdmiIconContainer)}>
        <img src={require('../assets/icons/mediaDnd/cms.png')} alt={media.title} style={{ width: '100%', maxHeight: '100%', objectFit: 'contain', maxWidth: '70%' }} />
      </div>)
    case 'PROG_AND_CMS':
      return (<div className={css(Styles.hdmiIconContainer)}>
        <img src={require('../assets/icons/mediaDnd/prog-cms.png')} alt={media.title} style={{ width: '100%', maxHeight: '100%', objectFit: 'contain', maxWidth: '70%' }} />
      </div>)
    default:
      return null
    }
  }

  const getStyledSections = () => {
    if (!layoutJson || !layoutJson.layoutjson || !layoutJson.layoutjson.sections) {
      return null
    }

    return layoutJson.layoutjson.sections.map((item, index) => {
      const keyValue = String(item.id) + index
      const currentMediaIndex = mediaIndexes[item.id] || 0;
      const currentMedia = item.media && item.media[currentMediaIndex] || null;
      const sectionStyle = {
        position: 'absolute',
        left: (item.x * scaleXY.x) + 'px',
        top: (item.y * scaleXY.y) + 'px',
        width: (item.width * scaleXY.x) + 'px',
        height: (item.height * scaleXY.y) + 'px',
        backgroundColor: displayMedia === true ? 'unset' : item.backgroundColor,
        zIndex: item.zIndex || 1,
      }
      return (
        <div
          onClick={() => { handleOnChangeSectionSelection({ item, index }) }}
          key={keyValue}
          className={css(
            item.id && selectedSection && selectedSection.id && item.id === selectedSection.id && Styles.selectedItem
          )}
          style={sectionStyle}
        >
          {displayMedia && currentMedia && renderMedia(currentMedia, sectionStyle)}
        </div>
      )
    })
  }

  // Outer container styles
  const containerStyles = {
    width:
      renderDimensions && renderDimensions.width
        ? renderDimensions.width
        : '100%',
    height:
      renderDimensions && renderDimensions.height
        ? renderDimensions.height
        : '100%',
    position: 'relative',
    overflow: 'hidden',
    // backgroundColor: '#f4f4f4',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // boxShadow: '0 2px 8px #00000026'
    boxShadow: 'rgb(204, 204, 204) 0px 1px 4px 0px'
  }

  // Inner layout container styles
  const layoutStyles = {
    position: 'relative',
    width: '100%',
    height: '100%',
    backgroundColor: displayMedia === true ? '#fff' : 'unset',
  }

  return (
    <div
      ref={containerRef}
      className={css(Styles.container)}
      style={containerStyles}
    >
      <div className={css(Styles.layout)} style={layoutStyles}>
        {getStyledSections()}
      </div>
    </div>
  )
}

const Styles = StyleSheet.create({
  container: {
  },
  layout: {
    // backgroundColor: '#fff',
  },
  selectedItem: {
    boxShadow: 'inset 0 0 2px #000000, inset 0 0 2px #0f0, inset 0 0 0px #0f0'
  },
  hdmiIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    background: '#e4e4e4',
    border: '1px solid white'
  }
})

export default LayoutPreview



// WEBPACK FOOTER //
// ./src/components/LayoutPreview.js